import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";

// Lazy-load toast component (only needed when toasts are triggered)
const Toaster = lazy(() => import("@/components/ui/toaster").then(m => ({ default: m.Toaster })));

// Critical page - loaded immediately for best FCP/LCP
import Index from "./pages/Index";

// Lazy load all other pages to reduce initial bundle size and improve TTI
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const RegistoMotorista = lazy(() => import("./pages/RegistoMotorista"));
const RequisitosMotoristaYango = lazy(() => import("./pages/RequisitosMotoristaYango"));
const CadastroMotorista = lazy(() => import("./pages/CadastroMotorista"));
const BaixarYangoProMaputo = lazy(() => import("./pages/BaixarYangoProMaputo"));
const RecargaAutomaticaYangoPro = lazy(() => import("./pages/RecargaAutomaticaYangoPro"));
const Documentation = lazy(() => import("./pages/Documentation"));
const NotFound = lazy(() => import("./pages/NotFound"));

// Minimal loading fallback
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="animate-pulse text-primary text-lg">Carregando...</div>
  </div>
);

const App = () => (
  <LanguageProvider>
    <Suspense fallback={null}>
      <Toaster />
    </Suspense>
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/registo-yango-motorista-maputo" element={<RegistoMotorista />} />
          <Route path="/requisitos-motorista-yango" element={<RequisitosMotoristaYango />} />
          <Route path="/cadastro-motorista-yango" element={<CadastroMotorista />} />
          <Route path="/baixar-yango-pro-maputo" element={<BaixarYangoProMaputo />} />
          <Route path="/recarga-automatica-yango-pro-emola-mpesa" element={<RecargaAutomaticaYangoPro />} />
          <Route path="/documentacao" element={<Documentation />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </LanguageProvider>
);

export default App;
